import styled from "styled-components";
import "./profile.sass";
import {Dispatch, SetStateAction, useEffect, useState} from "react";
import { FC} from "react";
import { User } from "../../../models/user";
import teamPlaceholderImage from "../../../images/common/vgc-logo.png"
import { useUser } from "../../../context/useUser";
import { Contract } from "../../../models/contract";
import AcceptContractModal from "../contracts/AcceptContractModal";
import ReactModal from "../../common/ReactModal";
import AcceptContractForm from "./AcceptContractForm";
import ViewContractForm from "./ViewContractForm";


interface Props {
  player: User;
}

const Contracts: FC<Props> = ({ player }) => {
  const { user } = useUser();

  // Data
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [contractToAccept, setContractToAccept] = useState<Contract>();

  // Methods
  const handleClickContract = (contract: Contract) => {
    if (!contract.isAccepted) {
      setSelectedContract(contract);
      setIsAcceptContractModalOpen(true);
    }
    if (contract.isAccepted) {
      setSelectedContract(contract);
      setIsViewContractModalOpen(true);
    }
  };
  const toggleContractModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  // Modals
  const [selectedContract, setSelectedContract] = useState<Contract | null>(null);

  const [isAcceptContractModalOpen, setIsAcceptContractModalOpen] = useState<boolean>(false);
  const [isViewContractModalOpen, setIsViewContractModalOpen] = useState<boolean>(false);

  const closeModals = () => {
    setSelectedContract(null);
    setIsAcceptContractModalOpen(false);
    setIsViewContractModalOpen(false);
  };


  return (
    <Wrapper>
      <Container className="profile-side-container black-border h-100">
        <HeaderContainer className="black-border">
          <HeaderTitleContainer className="gradient-gray heading">
            <HeaderTitle className="fw-bold">STATUS</HeaderTitle>
          </HeaderTitleContainer>
          <HeaderSignedContainer className="gradient-gray-light ">
            <HeaderSigned>
              {player.contractOffers.filter(contract => contract.isAccepted).length
                ? "SIGNED"
                : "FREE AGENT"}
            </HeaderSigned>
          </HeaderSignedContainer>
        </HeaderContainer>

        <FooterContainer>
          <div className="black-border mt-3">
            <ContractsContainer className="gradient-gray heading">
              <ContractsText className="fw-bold">CONTRACTS</ContractsText>
            </ContractsContainer>

            <ContractsInfoContainer>
              {player.contractOffers.length ? (
                <>
                  <BadgesContainer className=" row d-flex justify-content-center gradient-gray-light ">
                    {player.contractOffers.map((contract, i) => (
                      <div className="col-3 m-1 d-flex justify-content-center my-2 clickable" key={i}>
                        <BadgeContainer
                          onClick={() => handleClickContract(contract)}
                        >
                          <BadgeImage src={contract.team.image || teamPlaceholderImage} />
                        </BadgeContainer>
                      </div>
                    ))}
                  </BadgesContainer>
                </>
              ) : (
                <>
                  <BadgesContainer>
                    <BadgeImage></BadgeImage>
                  </BadgesContainer>
                </>
              )}
            </ContractsInfoContainer>
          </div>
          {player.contractOffers.length ? (
            <>
              <UnderContractBox className="gradient-gray dark-border black-border">
                <Text>
                  Under<br></br>Contract
                </Text>
              </UnderContractBox>
            </>
          ) : (
            <>
              <UnderContractBox className="gradient-gray dark-border">
                <Text>
                  Free<br></br>Agent
                </Text>
              </UnderContractBox>
            </>
          )}
        </FooterContainer>
      </Container>

    {/* Accept contract modal */}
    {modalIsOpen && contractToAccept ? (
      <AcceptContractModal
        contract={contractToAccept}
        closeModal={toggleContractModal}
      />
      ) : null}
      
    {/* Accept contract modal */}
    <ReactModal
      modalOpen={isAcceptContractModalOpen}
      closeModal={closeModals}
      component={selectedContract && (
        <AcceptContractForm
          contract={selectedContract}
          closeModal={closeModals}
        />
      )}
      />
      
    {/* View contract modal */}
    <ReactModal
      modalOpen={isViewContractModalOpen}
      closeModal={closeModals}
      component={selectedContract && (
        <ViewContractForm
          contract={selectedContract}
          closeModal={closeModals}
        />
      )}
    />

    </Wrapper>
  );
};

export default Contracts;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem 2rem;
  @media (max-width: 1200px) {
    padding: 1rem 1rem;
  }
  @media (max-width: 992px) {
    width: 350px;
  }
  @media (max-width: 768px) { 
  padding-top: 0;
  }
`;
const Container = styled.div`
  /* Removed height: 100% so container fits content */
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  row-gap: 0.5rem;
  background: linear-gradient(120deg, #000000ff 60%, #060b29ff 100%);
  border: 2px solid #5fa8e6;
  box-shadow: 0 0 5px 1px #00eaff;
  border-radius: 18px;
  padding: 1.5rem 1.2rem;
  position: relative;
  /* Removed height: 100% to allow container to fit content */
  @media (max-width: 992px) {
    flex-direction: column;
    gap: 0.5rem;
  }
  @media (max-width: 600px) {
    gap: 0.1rem;
  }
`;
// Header
const HeaderContainer = styled.div``;
const HeaderTitleContainer = styled.div`
  color: white;
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
  padding: 1rem;
  margin: 0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: 0.5px solid gray;
  border: 2px solid #5fa8e6;
  box-shadow: 0 0 12px 1px #00eaff;
`;
const HeaderTitle = styled.h4`
  padding: 0;
  margin: 0;
`;
const HeaderSignedContainer = styled.div`
  color: white;
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
  padding: 1rem;
  margin: 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border: 2px solid #5fa8e6;
  box-shadow: 0 0 12px 1px #00eaff;
`;
const HeaderSigned = styled.h4`
  margin: 0;
  padding: 0;
`;
// Footer
const FooterContainer = styled.div`
  /* height: 100%; */

  /* overflow: hidden; */
  display: flex;
  flex-direction: column;
  /* justify-content: space-around; */
  /* border: red 3px solid; */
  margin: 0;
  padding: 0;
  gap: 0.5rem;
  @media (max-width: 600px) {
    gap: 0.25rem;
  }
`;
const ContractsContainer = styled.div`
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
  padding: 1rem;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: 0.5px solid gray;
  border: 2px solid #5fa8e6;
  box-shadow: 0 0 12px 1px #00eaff;
`;
const ContractsText = styled.h4`
  padding: 0;
  margin: 0;
`;

// contracts
const ContractsInfoContainer = styled.div``;
const BadgesContainer = styled.div`
  /* height: 100%; */
  min-height: 100px;
  /* width: 100%; */
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  margin: 0;
  padding: 0;
  /* min-height: 180px; */
  /* margin: 0.5rem 1rem; */
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #5fa8e6;
  box-shadow: 0 0 12px 1px #00eaff;
  /* outline: red 2px solid; */
`;
const BadgeContainer = styled.div`
  height: 50px;
  width: 50px;
`;
const BadgeImage = styled.img`
  height: 100%;
  width: auto;
`;
const UnderContractBox = styled.div`
  border-radius: 8px;
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
  padding: 0.1rem;
  margin-top: 1rem;
  border: 2px solid #5fa8e6;
  box-shadow: 0 0 12px 1px #00eaff;
`;
const Text = styled.h5`
  padding: 0;
  margin: 0;
`;
